import script from "./getGivemoney.vue?vue&type=script&setup=true&lang=js"
export * from "./getGivemoney.vue?vue&type=script&setup=true&lang=js"

import "./getGivemoney.vue?vue&type=style&index=0&id=7ce4b4fc&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ce4b4fc"]])

export default __exports__